export const cityParkingStyles = {
	header: {
		backgroundColor: '#bbb9b9',
	},
	sidebar: {
		backgroundColor: '#bbb9b9',
		color: '#000000 !important',
	},
	title: {
		color: '#000000 !important',
	},
	button: {
		backgroundColor: '#e90e8b !important',
		color: '#fff !important',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#e26db0ff !important',
		},
	},
	text: {
		color: '#000000 !important',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#e90e8b',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'CityParking Inc.',
	},
	logo: {
		small: {
			src: '/cityParking/cityParkingShort.png',
			height: 35,
			width: 45,
		},
		large: {
			src: '/cityParking/cityParkingShort.png',
			height: 55,
			width: 65,
		},
	},
	favicon: {
		src: '/cityParking/cityParkingShort.png',
	},
	socials: {},
	siteUrl: 'https://cityparkingonline.com',
	orgName: 'CityParking',
};
